import styled, { css } from 'styled-components';

import MuiTableRow from '@mui/material/TableRow';

interface TableRowProps {
  /** is it a table body row or not */
  $isBody?: boolean;
}

export const TableRow = styled(MuiTableRow)<TableRowProps>`
  // when it's not a header, we want to change background color on hover

  &.MuiTableRow-root {
    ${({ $isBody }) =>
      $isBody &&
      css`
        &:hover {
          td {
            background-color: ${({ theme }) => theme.colors.grey3};

            &:first-child {
              border-top-left-radius: 6px;
              border-bottom-left-radius: 6px;
            }

            &:last-child {
              border-bottom-right-radius: 6px;
              border-top-right-radius: 6px;
            }
          }
        }
      `};
  }
`;
